

















import {Component, Vue, Prop, Mixins} from 'vue-property-decorator';
import {Mixin} from "@/mixins";

@Component({
    name: "OptionsIcons",
})
export default class OptionsIcons extends Mixins(Mixin) {
    @Prop({required: false, default: () => 'icon'})
    mode!: 'icon'|'text';

    @Prop({required: false, default: () => null})
    iconUrl?: string;

    @Prop({required: false, default: () => null})
    iconAlt?: string;

    @Prop({required: false, default: () => null})
    text?: string;
}
